__turbopack_context__.v({
  "root": "styles-module-scss-module__Giq8RW__root",
  "withPwa": "styles-module-scss-module__Giq8RW__withPwa",
});
